export const ArtIcon = () => (
  <svg
    className="menu-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="40px"
    height="40px"
    viewBox="0 0 512 512"
  >
    <g id="_x32_3_x2C__art_x2C__graphic_x2C__pc_x2C__ui_ux_x2C__visual">
      <g id="XMLID_858_">
        <g id="XMLID_871_">
          <g id="XMLID_22_">
            <path
              d="M456.333,425.571H55.667C36.551,425.571,21,410.02,21,390.904v-30.333c0-2.762,2.239-5,5-5h460      c2.762,0,5,2.238,5,5v30.333C491,410.02,475.448,425.571,456.333,425.571z M31,365.571v25.333      c0,13.602,11.065,24.667,24.667,24.667h400.667c13.602,0,24.667-11.065,24.667-24.667v-25.333H31z"
              id="XMLID_368_"
              fill="none"
              stroke="currentColor"
              strokeWidth="8"
            />
          </g>

          <g id="XMLID_21_">
            <path
              d="M486,365.571H26c-2.761,0-5-2.238-5-5v-223.5c0-22.883,18.617-41.5,41.5-41.5h174.002      c2.761,0,5,2.239,5,5s-2.239,5-5,5H62.5c-17.369,0-31.5,14.131-31.5,31.5v218.5h450v-218.5c0-17.369-14.131-31.5-31.5-31.5      H335.497c-2.762,0-5-2.239-5-5s2.238-5,5-5H449.5c22.883,0,41.5,18.617,41.5,41.5v223.5      C491,363.333,488.762,365.571,486,365.571z"
              id="XMLID_367_"
              fill="none"
              stroke="currentColor"
              strokeWidth="8"
            />
          </g>

          <g id="XMLID_20_">
            <path
              d="M177.508,214.063c-1.307,0-2.584-0.513-3.536-1.464c-1.301-1.301-1.782-3.21-1.253-4.972l21.213-70.71      c0.238-0.793,0.668-1.514,1.253-2.099L311.858,18.145c7.555-7.555,17.6-11.716,28.283-11.716      c10.685,0,20.729,4.161,28.284,11.716c7.556,7.555,11.717,17.6,11.717,28.284c0,10.685-4.161,20.729-11.717,28.285      L251.754,191.386c-0.585,0.585-1.306,1.016-2.099,1.253l-70.71,21.213C178.472,213.995,177.988,214.063,177.508,214.063z       M203.147,140.997l-18.182,60.609l60.609-18.183L361.355,67.642c5.666-5.667,8.787-13.2,8.787-21.213      c0-8.013-3.121-15.547-8.787-21.213c-5.666-5.667-13.2-8.787-21.214-8.787c-8.013,0-15.547,3.121-21.213,8.787L203.147,140.997z      "
              id="XMLID_364_"
              fill="none"
              stroke="currentColor"
              strokeWidth="8"
            />
          </g>

          <g id="XMLID_19_">
            <path
              d="M216.398,167.913c-5.762,0-11.523-2.193-15.91-6.579c-8.772-8.773-8.772-23.047,0-31.82      c1.952-1.952,5.118-1.952,7.071,0c1.953,1.953,1.953,5.118,0,7.071c-4.874,4.874-4.874,12.804,0,17.678s12.804,4.874,17.678,0      c1.954-1.952,5.119-1.951,7.071,0c1.953,1.953,1.953,5.119,0,7.071C227.922,165.72,222.16,167.913,216.398,167.913z"
              id="XMLID_363_"
              fill="none"
              stroke="currentColor"
              strokeWidth="8"
            />
          </g>

          <g id="XMLID_18_">
            <path
              d="M241.147,192.673c-6.01,0-11.66-2.341-15.91-6.59s-6.59-9.9-6.59-15.91c0-6.01,2.341-11.661,6.59-15.91      l62.228-62.227c1.951-1.952,5.119-1.952,7.07,0c1.953,1.953,1.953,5.119,0,7.071l-62.227,62.227      c-2.361,2.361-3.662,5.5-3.662,8.839c0,3.338,1.3,6.478,3.662,8.838c2.361,2.361,5.5,3.662,8.838,3.662      c3.339,0,6.478-1.3,8.839-3.662c1.952-1.952,5.119-1.952,7.071,0c1.953,1.953,1.953,5.118,0.001,7.071      C252.808,190.332,247.157,192.673,241.147,192.673z"
              id="XMLID_362_"
              fill="none"
              stroke="currentColor"
              strokeWidth="8"
            />
          </g>

          <g id="XMLID_17_">
            <path
              d="M350.749,90.32c-1.279,0-2.56-0.488-3.535-1.464l-49.498-49.498c-1.953-1.953-1.953-5.119,0-7.071      c1.951-1.952,5.119-1.952,7.07,0l49.498,49.498c1.953,1.953,1.953,5.119,0,7.071C353.309,89.832,352.028,90.32,350.749,90.32z"
              id="XMLID_361_"
              fill="none"
              stroke="currentColor"
              strokeWidth="8"
            />
          </g>

          <g id="XMLID_16_">
            <path
              d="M366,315.571h-80c-16.542,0-30-13.458-30-30s13.458-30,30-30h110c11.028,0,20-8.972,20-20v-1.508      c0-11.028-8.972-20-20-20H177.508c-2.761,0-5-2.239-5-5s2.239-5,5-5H396c16.542,0,30,13.458,30,30v1.508      c0,16.542-13.458,30-30,30H286c-11.028,0-20,8.972-20,20s8.972,20,20,20h80c2.762,0,5,2.238,5,5S368.762,315.571,366,315.571z"
              id="XMLID_360_"
              fill="none"
              stroke="currentColor"
              strokeWidth="8"
            />
          </g>

          <g id="XMLID_15_">
            <path
              d="M176,320.571H26c-2.761,0-5-2.238-5-5s2.239-5,5-5h150c2.761,0,5,2.238,5,5      S178.761,320.571,176,320.571z"
              id="XMLID_359_"
              fill="none"
              stroke="currentColor"
              strokeWidth="8"
            />
          </g>

          <g id="XMLID_14_">
            <path
              d="M176,290.571H26c-2.761,0-5-2.238-5-5s2.239-5,5-5h150c2.761,0,5,2.238,5,5      S178.761,290.571,176,290.571z"
              id="XMLID_358_"
              fill="none"
              stroke="currentColor"
              strokeWidth="8"
            />
          </g>

          <g id="XMLID_13_">
            <path
              d="M176,260.571H26c-2.761,0-5-2.238-5-5c0-2.761,2.239-5,5-5h150c2.761,0,5,2.239,5,5      C181,258.333,178.761,260.571,176,260.571z"
              id="XMLID_357_"
              fill="none"
              stroke="currentColor"
              strokeWidth="8"
            />
          </g>
        </g>

        <g id="XMLID_12_">
          <path
            d="M311,485.571H201c-2.761,0-5-2.238-5-5v-60c0-2.762,2.239-5,5-5h110c2.762,0,5,2.238,5,5v60     C316,483.333,313.762,485.571,311,485.571z M206,475.571h100v-50H206V475.571z"
            id="XMLID_315_"
            fill="none"
            stroke="currentColor"
            strokeWidth="8"
          />
        </g>

        <g id="XMLID_11_">
          <path
            d="M286,485.571h-60c-2.761,0-5-2.238-5-5v-60c0-2.762,2.239-5,5-5h60c2.762,0,5,2.238,5,5v60     C291,483.333,288.762,485.571,286,485.571z M231,475.571h50v-50h-50V475.571z"
            id="XMLID_312_"
            fill="none"
            stroke="currentColor"
            strokeWidth="8"
          />
        </g>

        <g id="XMLID_10_">
          <path
            d="M326,505.571H186c-8.271,0-15-6.729-15-15s6.729-15,15-15h140c8.271,0,15,6.729,15,15     S334.271,505.571,326,505.571z M186,485.571c-2.757,0-5,2.243-5,5s2.243,5,5,5h140c2.757,0,5-2.243,5-5s-2.243-5-5-5H186z"
            id="XMLID_309_"
            fill="none"
            stroke="currentColor"
            strokeWidth="8"
          />
        </g>
      </g>
    </g>

    <g id="Layer_1" />
  </svg>
);
